// extracted by mini-css-extract-plugin
export default {"reply_message":"replyMessage_reply_message__XJfr1","reply_message__support":"replyMessage_reply_message__support__NVxNH"};